import React from 'react'

const FocusBox = props => {
  const { children = <></> } = props

  return <div className={'wfocus-box'}>{children}</div>
}

export default FocusBox
